export default "__VITE_ASSET__5e1a4de9__"